import React from 'react';

const FooterRunwayStyle = () => {
  return (
    <footer className="bg-black text-white pt-5 pb-4 mt-5">
      <div className="container">
        <div className="row row-cols-2 row-cols-md-4 g-4">
          <div>
            <h6 className="fw-bold mb-3">Our Tools</h6>
            <ul className="list-unstyled small">
              <li>API</li>
              <li>Gen-4</li>
              <li>Act-One</li>
              <li>Use Cases</li>
              <li>General Models</li>
            </ul>
          </div>
          <div>
            <h6 className="fw-bold mb-3">Studios</h6>
            <ul className="list-unstyled small">
              <li>AI Film Festival</li>
              <li>Gen:48</li>
              <li>Watch</li>
              <li>Academy</li>
              <li>Creative Partners</li>
            </ul>
          </div>
          <div>
            <h6 className="fw-bold mb-3">Company</h6>
            <ul className="list-unstyled small">
              <li>About Us</li>
              <li>Careers</li>
              <li>News</li>
              <li>Store</li>
              <li>Talent Network</li>
            </ul>
          </div>
          <div>
            <h6 className="fw-bold mb-3">More</h6>
            <ul className="list-unstyled small">
              <li>Twitter</li>
              <li>Instagram</li>
              <li>YouTube</li>
              <li>Discord</li>
              <li>Changelog</li>
            </ul>
          </div>
        </div>

        <div className="mt-4 d-flex justify-content-between align-items-center border-top border-secondary pt-3">
          <span className="fw-bold">Connexions Narratives</span>
          <small className="fw-bold" > © {new Date().getFullYear()} Connexions Narratives. Tous droits réservés.</small>
        </div>
      </div>
    </footer>
  );
};

export default FooterRunwayStyle;
